export enum BuyCryptoMethods {
  CARD = 'CARD',
  WIRE = 'WIRE',
  BALANCE = 'BALANCE',
}
